import { ENTITY_TYPES } from "utils/constants";
import Helpers from "../../services/helpers";
import { generateCardTitle } from "../../utils/cardList";

export const endingAvgPriceModel = (_entityType) => ({
  cartesianGridStrokeDasharray: "3 3",
  xAxisTick: false,
  xAxisDataKey: "entityName",
  yAxisTickFormatter: (value) => Helpers.formatMoney(value, 0),
  bars: [
    {
      dataKey: "endAverageValue",
    },
  ],

  dataFn: (entities, entityType) => payloadDataToEndAvgPriceData(entities, entityType),
});

const payloadDataToEndAvgPriceData = (entities, entityType) => {
  return entities.map((entry) => {
    const to = {};
    endingAvgPriceModel(entityType).bars.forEach((bar) => {
      to.color = entry.color;
      to.dataKey = entry.dataKey;
      to[endingAvgPriceModel(entityType).xAxisDataKey] = entry.payload.name;

      if (entityType === ENTITY_TYPES.CARD) {
        to.cardId = entry.cardId;
        to[bar.dataKey] = entry.payload?.historical_stats?.all_end_avg || 0;
      } else if (entityType === ENTITY_TYPES.SEALED_WAX) {
        to.sealedWaxId = entry.sealedWaxId;
        to[bar.dataKey] = entry.payload?.sealed_wax_stats?.all_end_avg || 0;
      }
    });
    return to;
  });
};

export const entitiesToPayload = (entities, entityType = ENTITY_TYPES.CARD, dataKey, lineProps) => {
  const identifier = {
    [ENTITY_TYPES.CARD]: "cardId",
    [ENTITY_TYPES.SEALED_WAX]: "sealedWaxId",
  }[entityType];

  return entities.map((entity) => {
    const to = {
      [identifier]: entity.id,
      color: lineProps.find((prop) => prop[identifier] === entity.id)?.stroke,
      dataKey: `${entity.id}_${dataKey}`,
      payload: {
        ...entity,
        smallImage: Helpers.pickMmImage(entity, "S"),
        image: Helpers.pickMmImage(entity),
      },
    };

    switch (entityType) {
      case ENTITY_TYPES.CARD: {
        to.value = generateCardTitle(entity);
        to.payload.name = generateCardTitle(entity, { hideSport: true });
        to.payload.nameWOGrade = generateCardTitle(entity, { hideSport: true, hideGrade: true });
        to.payload.hasAlert = Boolean(entity.has_alert);
        to.payload.popCount = entity.population_count;
        to.payload.popCountLastUpdated = entity.population_last_updated;
        to.payload.serialNumber = entity.serial_number;
        to.payload.grade = (entity.grade && (entity.grade.abbreviation || entity.grade.name)) || "";
        to.payload.isRookieCard = entity.player?.rookie_years
          ? entity.player.rookie_years.includes(entity.card_set.year)
          : false;
        break;
      }
      case ENTITY_TYPES.SEALED_WAX: {
        to.value = Helpers.getSealedWaxName(entity);
        to.payload.name = Helpers.getSealedWaxName(entity);
        to.payload.nameWOGrade = Helpers.getSealedWaxName(entity, { hideBoxType: true });
        to.payload.grade = entity.box_type?.name;
        to.payload.hasAlert = Boolean(entity.has_alert);
        break;
      }
      default:
        break;
    }

    return to;
  });
};
